export var ComparisonOperators;
(function (ComparisonOperators) {
    ComparisonOperators["MATCH_GREATER_OR_EQUAL"] = ">=";
    ComparisonOperators["MATCH_LESS_OR_EQUAL"] = "<=";
    ComparisonOperators["MATCH_GREATER"] = ">";
    ComparisonOperators["MATCH_LESS"] = "<";
    ComparisonOperators["MATCH_LOGICAL_EQUAL"] = "=";
    ComparisonOperators["MATCH_GTE"] = "more_or_equals";
    ComparisonOperators["MATCH_LTE"] = "less_or_equals";
    ComparisonOperators["MATCH_GT"] = "more_than";
    ComparisonOperators["MATCH_LT"] = "less_than";
    ComparisonOperators["MATCH_CONTAINS"] = "contains";
    ComparisonOperators["MATCH_DOES_NOT_CONTAIN"] = "not_contains";
    ComparisonOperators["MATCH_EQUALS"] = "equals";
    ComparisonOperators["MATCH_NOT_EQUALS"] = "not_equals";
    ComparisonOperators["MATCH_STARTS_WITH"] = "starts_with";
    ComparisonOperators["MATCH_DOES_NOT_START_WITH"] = "not_starts_with";
    ComparisonOperators["MATCH_ENDS_WITH"] = "ends_with";
    ComparisonOperators["MATCH_DOES_NOT_END_WITH"] = "not_ends_with";
    ComparisonOperators["MATCH_REGEX"] = "matches_regex";
    ComparisonOperators["MATCH_IN"] = "matchIn";
    ComparisonOperators["MATCH_BETWEEN"] = "between";
    ComparisonOperators["DOES_NOT_MATCH_IN"] = "not_matchIn";
    ComparisonOperators["DOES_NOT_MATCH_REGEX"] = "not_matches_regex";
    ComparisonOperators["IS_EMPTY"] = "is_empty";
    ComparisonOperators["NOT_IS_EMPTY"] = "not_is_empty";
    ComparisonOperators["EXISTS"] = "exists";
    ComparisonOperators["NOT_EXISTS"] = "not_exists";
    ComparisonOperators["HAS_ANY"] = "hasAny";
    ComparisonOperators["NOT_HAS_ANY"] = "not_hasAny";
    ComparisonOperators["HAS_ALL"] = "hasAll";
    ComparisonOperators["NOT_HAS_ALL"] = "not_hasAll";
})(ComparisonOperators || (ComparisonOperators = {}));
export const invertComparisonOperator = (operator) => {
    switch (operator) {
        case ComparisonOperators.MATCH_GREATER_OR_EQUAL:
            return ComparisonOperators.MATCH_LESS;
        case ComparisonOperators.MATCH_LESS:
            return ComparisonOperators.MATCH_GREATER_OR_EQUAL;
        case ComparisonOperators.MATCH_GREATER:
            return ComparisonOperators.MATCH_LESS_OR_EQUAL;
        case ComparisonOperators.MATCH_LESS_OR_EQUAL:
            return ComparisonOperators.MATCH_GREATER;
        case ComparisonOperators.MATCH_GTE:
            return ComparisonOperators.MATCH_LT;
        case ComparisonOperators.MATCH_LTE:
            return ComparisonOperators.MATCH_GT;
        case ComparisonOperators.MATCH_GT:
            return ComparisonOperators.MATCH_LTE;
        case ComparisonOperators.MATCH_LT:
            return ComparisonOperators.MATCH_GTE;
        case ComparisonOperators.MATCH_CONTAINS:
            return ComparisonOperators.MATCH_DOES_NOT_CONTAIN;
        case ComparisonOperators.MATCH_DOES_NOT_CONTAIN:
            return ComparisonOperators.MATCH_CONTAINS;
        case ComparisonOperators.MATCH_EQUALS:
            return ComparisonOperators.MATCH_NOT_EQUALS;
        case ComparisonOperators.MATCH_NOT_EQUALS:
            return ComparisonOperators.MATCH_EQUALS;
        case ComparisonOperators.MATCH_STARTS_WITH:
            return ComparisonOperators.MATCH_DOES_NOT_START_WITH;
        case ComparisonOperators.MATCH_DOES_NOT_START_WITH:
            return ComparisonOperators.MATCH_STARTS_WITH;
        case ComparisonOperators.MATCH_ENDS_WITH:
            return ComparisonOperators.MATCH_DOES_NOT_END_WITH;
        case ComparisonOperators.MATCH_DOES_NOT_END_WITH:
            return ComparisonOperators.MATCH_ENDS_WITH;
        case ComparisonOperators.MATCH_REGEX:
            return ComparisonOperators.DOES_NOT_MATCH_REGEX;
        case ComparisonOperators.MATCH_IN:
            return ComparisonOperators.DOES_NOT_MATCH_IN;
        case ComparisonOperators.DOES_NOT_MATCH_IN:
            return ComparisonOperators.MATCH_IN;
        case ComparisonOperators.DOES_NOT_MATCH_REGEX:
            return ComparisonOperators.MATCH_REGEX;
        case ComparisonOperators.IS_EMPTY:
            return ComparisonOperators.NOT_IS_EMPTY;
        case ComparisonOperators.NOT_IS_EMPTY:
            return ComparisonOperators.IS_EMPTY;
        case ComparisonOperators.EXISTS:
            return ComparisonOperators.NOT_EXISTS;
        case ComparisonOperators.NOT_EXISTS:
            return ComparisonOperators.EXISTS;
        case ComparisonOperators.HAS_ALL:
            return ComparisonOperators.NOT_HAS_ALL;
        case ComparisonOperators.NOT_HAS_ALL:
            return ComparisonOperators.HAS_ALL;
        case ComparisonOperators.HAS_ANY:
            return ComparisonOperators.NOT_HAS_ANY;
        case ComparisonOperators.NOT_HAS_ANY:
            return ComparisonOperators.HAS_ANY;
    }
};
//# sourceMappingURL=comparison-operators.js.map